module.exports = __webpack_public_path__ + "img/gj.86843d00.png";